import { notifiedPassageNoticeSchema, passageNoticePageSchema, passageNoticeSchema, recordedFollowUpStepSchema, } from '@ghp/domain';
import { bearer } from './http.js';
/**
 * Les **avis de passage** — le constat qu'un agent s'est déplacé sans pouvoir contrôler, et
 * l'e-mail que le bureau envoie à l'usager.
 *
 * ⚠️ **Deux publics par le même client.** `record` est le geste d'une tablette, les trois autres
 * celui du bureau ; c'est le serveur qui tranche, route par route. Le client d'API les expose
 * ensemble parce qu'il sert les deux apps — comme `sync`.
 */
export function createPassageNoticesEndpoints(http) {
    return {
        /**
         * Dépose le constat de la tablette.
         *
         * ⚠️ **La clé d'idempotence est obligatoire, et métier.** Un agent hors réseau qui appuie
         * deux fois, ou une file d'envoi qui rejoue, produirait sinon deux avis pour le même passage.
         * Elle se compose de la demande et de l'instant du passage, jamais d'un `randomUUID()` —
         * celui-ci changerait à chaque rejeu et n'écarterait rien.
         */
        record(accessToken, input) {
            return http.postJson('/passage-notices', input, passageNoticeSchema, bearer(accessToken));
        },
        /** La liste du bureau, la plus récente d'abord, avec ses deux effectifs. */
        list(accessToken) {
            return http.get('/passage-notices', passageNoticePageSchema, bearer(accessToken));
        },
        /**
         * Envoie l'avis à l'usager — la réponse porte l'avis remis à jour **et** si l'e-mail est
         * parti.
         *
         * ⚠️ **`emailQueued: false` n'est pas une erreur** : personne à qui écrire, ou envoi déjà en
         * file. L'écran le dit plutôt que de laisser croire l'usager averti (M21).
         */
        sendEmail(accessToken, noticeId) {
            return http.postJson('/passage-notices/email', { noticeId }, notifiedPassageNoticeSchema, bearer(accessToken));
        },
        /** Clôt l'avis — sans envoi est un cas normal, l'usager a rappelé de lui-même. */
        settle(accessToken, noticeId) {
            return http.postJson('/passage-notices/settle', { noticeId }, passageNoticeSchema, bearer(accessToken));
        },
        /**
         * « Étape faite » (M40) : l'étape suivante de la suite du client, par e-mail ou par courrier ;
         * un RDV1 ou un RDV2 pose le rendez-vous qu'il impose (#574). Rend la ligne à jour, et si la
         * confirmation du rendez-vous est partie ; `409` quand il n'y a plus d'étape à faire.
         */
        recordStep(accessToken, noticeId, step) {
            return http.postJson('/passage-notices/steps', { noticeId, ...step }, recordedFollowUpStepSchema, bearer(accessToken));
        },
        /** « Exporter (CSV) » (M40) : la sélection, pour préparer les courriers. */
        exportCsv(accessToken, noticeIds) {
            return http.postFile('/passage-notices/export', { noticeIds }, bearer(accessToken));
        },
    };
}
//# sourceMappingURL=passage-notices.js.map